import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=2cdd86d6&scoped=true&"
import script from "./Cart.vue?vue&type=script&lang=js&"
export * from "./Cart.vue?vue&type=script&lang=js&"
import style0 from "./Cart.vue?vue&type=style&index=0&id=2cdd86d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdd86d6",
  null
  
)

export default component.exports